import { render } from "react-dom";
import { ErrorMessage, Field, FieldArray, Form, Formik, errors } from "formik";
import {
  Button,
  FormHelperText,
  FormLabel,
  Grid,
  Box,
  InputAdornment,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomTextField from "../../../Components/TextField";
import * as yup from "yup";
import { useEffect, useState, createRef, useRef } from "react";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import "./style.css";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "../../../Components/ErrorHandler/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import {
  createProgramCommitments,
  updateProgramDayDetails,
  RemoveCommitmentDetails,
  SAVE_SINGLE_COMMITMENT_DETAILS,
} from "../../../Redux/Actions/ProgramAction";
import { useErrorHandler } from "../../../hooks";
import rightArrow from "../../../Assets/Images/right-arrow.png";
import LeftArrow from "../../../Assets/Images/left-arrow.png";
import ReactLoading from "react-loading";
import ResponsiveDialog from "../../../Components/DialogBox";
import { useNavigate } from "react-router";
import MyEditor from "../../../Components/MyEditor";

export function CommitmentForm({ setStepOneData, _handleBack, formValue }) {
  const { setMsgConfig } = useErrorHandler();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myDivRef = useRef(null);
  //state
  const [programsDetails, setProgramsDetails] = useState({
    duration: "",
    id: "",
  });
  const [toastMsg, setToastMsg] = useState({ msg: "", state: false });
  const [selectedCommit, setSelectedCommit] = useState();
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const [dayId, setDayId] = useState(1);
  const [dayDetails, setDayDetails] = useState({});
  const [CommitmentLen, setCommitmentLen] = useState();
  const [tempDayDetails, setTempDayDetails] = useState({});
  const [commitLength, setCommitLength] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [isVisibleDialog, setIsVisibleDialog] = useState(false);
  const [changeMode, setChangeMode] = useState(false);
  const [dayChangeMode, setDayChangeMode] = useState(false);
  //get data of program commitments
  const { isEdit, getProgramDetails, loading, createProgram } = useSelector(
    (state) => state?.Program
  );

  //handle outside box click
  useEffect(() => {
    function handleClickOutside(event) {
      if (myDivRef.current && !myDivRef.current.contains(event.target)) {
        if (changeMode || dayChangeMode) {
          setIsVisibleDialog(true);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [myDivRef, navigate, dayChangeMode, changeMode]);

  //set commitment length for validation
  useEffect(() => {
    getProgramDetails?.commitments?.map((item) => {
      if (item?.day === dayId) {
        setCommitmentLen(item.commitment_details?.length);
      }
    });
  }, [getProgramDetails?.commitments, dayId]);

  //set program details
  useEffect(() => {
    createProgram?.programDetails &&
      createProgram?.programDetails?.map((item) => {
        setProgramsDetails({
          duration: item.duration,
          id: item.id,
        });
      });
  }, [createProgram?.programDetails]);

  //set single day details
  useEffect(() => {
    let tempArr = [];
    if (createProgram?.programCommitments) {
      const findCommitIndex = createProgram?.programCommitments?.findIndex(
        (data) => dayId === data?.day
      );
      setDayDetails(createProgram?.programCommitments[findCommitIndex]);
    }
    if (isEdit && getProgramDetails) {
      tempArr = getProgramDetails?.commitments?.map((item) => {
        return item;
      });
    }
    if (tempArr) {
      const findCommit = tempArr?.find((data) => dayId === data?.day);
      setTempDayDetails({ ...findCommit });
    }
    setCommitLength(
      createProgram?.programCommitments?.length ||
        getProgramDetails?.commitments?.length
    );
    setTotalDays(
      programsDetails?.duration * 7 || getProgramDetails?.duration * 7
    );
  }, [
    createProgram?.programCommitments,
    dayId,
    getProgramDetails,
    commitLength,
    totalDays,
  ]);

  //handle back
  const handleBack = () => {
    if (dayChangeMode || changeMode) {
      setIsVisibleDialog(true);
    } else {
      return _handleBack();
    }
  };

  //handle next
  const handleNext = (values) => {
    if (commitLength === totalDays) {
      let is_valid = true;
      if (isEdit) {
        for (
          let index = 0;
          index < getProgramDetails.commitments.length;
          index++
        ) {
          if (
            getProgramDetails.commitments[index]?.commitment_details?.length ===
            0
          ) {
            is_valid = false;
            break;
          }
        }
      } else if (!isEdit) {
        for (
          let index = 0;
          index < createProgram?.programCommitments?.length;
          index++
        ) {
          if (
            createProgram?.programCommitments?.[index]?.commitment_details
              ?.length === 0
          ) {
            is_valid = false;
            break;
          }
        }
      }
      if (!is_valid) {
        setIsVisibleDialog(true);
      } else {
        if (changeMode || dayChangeMode) {
          setIsVisibleDialog(true);
        } else {
          if(getProgramDetails?.is_publish === false){
            setStepOneData(values);
            }
            else{
              navigate("/programs")
           }
        }
      }
    } else {
      setIsVisibleDialog(true);
    }
  };

  //handle press enter
  const handleKeyPress1 = (event) => {
    if (event?.key === "Enter") {
      fileInputRef1?.current?.click();
    }
  };
  const handleKeyPress2 = (event) => {
    if (event?.key === "Enter") {
      fileInputRef2?.current?.click();
    }
  };

  const customHandleClose = () => {
    setToastMsg({ msg: "", state: false });
  };

  return (
    <>
      {loading ? (
        <>
          <Box className="loading-align">
            <ReactLoading
              type="spin"
              height="50px"
              width="50px"
              color="#39a2e8"
            />
          </Box>
          <Box className="loader-heading" sx={{ color: "#077eb0" }}>
            <Typography sx={{ fontSize: "15px" }}>Wait a moment</Typography>
          </Box>
        </>
      ) : (
        <Formik
          initialValues={{
            day:
              (isEdit && tempDayDetails && tempDayDetails.day) ||
              dayDetails?.day ||
              dayId,
            dayTitle:
              (isEdit && tempDayDetails && tempDayDetails.title) ||
              dayDetails?.title ||
              "",
            commitments: (dayDetails?.commitment_details &&
              dayDetails?.commitment_details.length >= 1 &&
              dayDetails?.commitment_details?.map((data, index) => ({
                commitment_title:
                  dayDetails?.commitment_details?.[index]?.commitment_title ||
                  "",
                cover_img:
                  dayDetails?.commitment_details?.[index]?.cover_img || "",
                short_description:
                  dayDetails?.commitment_details?.[index]?.short_description ||
                  "",
                description:
                  dayDetails?.commitment_details?.[index]?.description || "",
                content_file:
                  dayDetails?.commitment_details?.[index]?.content_file || "",

                id: dayDetails?.commitment_details?.[index]?.id || "",
                file_name:
                  dayDetails?.commitment_details?.[index]?.file_name || "",
                content_file_name:
                  dayDetails?.commitment_details?.[index]?.content_file_name ||
                  "",
                content_duration:
                  dayDetails?.commitment_details?.[index]?.content_duration ||
                  null,
              }))) ||
              (tempDayDetails?.commitment_details &&
                isEdit &&
                tempDayDetails?.commitment_details.length >= 1 &&
                tempDayDetails?.commitment_details?.map((data, index) => ({
                  commitment_title:
                    tempDayDetails?.commitment_details?.[index]
                      ?.commitment_title || "",
                  cover_img:
                    tempDayDetails?.commitment_details?.[index]?.cover_img ||
                    "",
                  short_description:
                    tempDayDetails?.commitment_details?.[index]
                      ?.short_description || "",
                  description:
                    tempDayDetails?.commitment_details?.[index]?.description ||
                    "",
                  content_file:
                    tempDayDetails?.commitment_details?.[index]?.content_file ||
                    "",
                  id: tempDayDetails?.commitment_details?.[index]?.id || "",
                  is_change:
                    tempDayDetails?.commitment_details?.[index]?.is_change ||
                    false,
                  file_name:
                    tempDayDetails?.commitment_details?.[index]?.file_name ||
                    "",
                  content_file_name:
                    tempDayDetails?.commitment_details?.[index]
                      ?.content_file_name || "",
                  content_duration:
                    tempDayDetails?.commitment_details?.[index]
                      ?.content_duration || null,
                }))) || [
                {
                  commitment_title: "",
                  cover_img: "",
                  short_description: "",
                  description: "",
                  content_file: "",
                  file_name: "",
                  content_file_name: "",
                  content_duration: null,
                },
              ],
          }}
          enableReinitialize={true}
          validationSchema={yup.object({
            day: yup.string().required("day Required"),
            dayTitle: yup
              .string()
              .required("dayTitle Required")
              .matches(
                /^\S.*/,
                "* This field cannot contain whitepaces at first letter"
              ),

            commitments: yup.array().of(
              yup.object().shape({
                commitment_title: yup
                  .string()
                  .required("commitmentTitle Required")
                  .matches(
                    /^\S.*/,
                    "* This field cannot contain whitepaces at first letter"
                  ),

                cover_img: yup
                  .mixed()
                  .required("A file is required")
                  .test(
                    "fileFormat",
                    "JPEG JPG AND PNG Files only",
                    (value) => {
                      const file = new File([value], "tempimage", {
                        type: value?.type || "image/jpeg",
                      });
                      const final_file = new File([file], file.name, {
                        type: file.type,
                      });

                      return (
                        !final_file ||
                        (final_file &&
                          ["image/jpeg", "image/png", "image/jpg"].includes(
                            final_file.type
                          ))
                      );
                    }
                  ),
                short_description: yup
                  .string()
                  .required("Short commitment Description Required")
                  .matches(
                    /^\S.*/,
                    "* This field cannot contain whitepaces at first letter"
                  ),
                description: yup
                  .string()
                  .required("commitment Description Required")
                  .matches(
                    /^\S.*/,
                    "* This field cannot contain whitepaces at first letter"
                  ),

                content_file: yup
                  .mixed()
                  .required("A file is required")
                  .test(
                    "fileFormat",
                    "Please Select MP4 File or IMAGE File",
                    (value) => {
                      const file = new File([value], "tempvideo", {
                        type: value?.type || "video/mp4",
                      });

                      return (
                        !file ||
                        (file &&
                          [
                            "video/mp4",
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                          ].includes(file.type))
                      );
                    }
                  ),
              })
            ),
          })}
          onSubmit={(values, { setTouched }) => {
            if (changeMode) {
              setIsVisibleDialog(true);
            } else if (!changeMode) {
              setDayChangeMode(false);

              const touched = values.commitments.reduce(
                (acc, curr, index) => ({
                  ...acc,
                  [`commitments.${index}.cover_img`]: true,
                  [`commitments.${index}.content_file`]: true,
                }),
                {}
              );

              setTimeout(() => {
                setTouched(touched);
              }, 0);

              const data = new FormData();
              data.append("day", values.day);

              data.append(
                "program_id",
                (programsDetails && programsDetails?.id) ||
                  (getProgramDetails && getProgramDetails?.id)
              );
              data.append("title", values.dayTitle);
              data.append("commitments", JSON.stringify(values.commitments));
              for (let index = 0; index < values.commitments.length; index++) {
                const element = values.commitments[index].cover_img;
                if ("object" == typeof values.commitments[index].cover_img) {
                  data.append("cover_img", element);
                }
              }
              for (let index = 0; index < values.commitments.length; index++) {
                const element = values.commitments[index].content_file;
                if ("object" == typeof values.commitments[index].content_file) {
                  data.append("content_file", element);
                }
              }
              data.append(
                "commitment_id",
                (tempDayDetails && tempDayDetails?.id) ||
                  (dayDetails && dayDetails?.id) ||
                  ""
              );

              if (isEdit) {
                dispatch(updateProgramDayDetails(data));
                !loading &&
                  setMsgConfig({
                    alertOpen: true,
                    message: "Data Update Successfully!",
                    severity: "success",
                    autoHideDuration: 2000,
                  });
              } else if (!isEdit) {
                const checkCommitExist =
                  createProgram?.programCommitments?.find(
                    (data) => data?.day === dayId
                  );
                if (!!checkCommitExist) {
                  dispatch(createProgramCommitments(data));
                  !loading &&
                    setMsgConfig({
                      alertOpen: true,
                      message: "Data Updated Successfully!",
                      severity: "success",
                      autoHideDuration: 2000,
                    });
                } else {
                  dispatch(createProgramCommitments(data));
                  !loading &&
                    setMsgConfig({
                      alertOpen: true,
                      message: "Data Created Successfully!",
                      severity: "success",
                      autoHideDuration: 2000,
                    });
                }
              }
            }
          }}
          render={({
            values,
            touched,
            errors,
            setFieldValue,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldTouched,
          }) => (
            <Form ref={myDivRef}>
              <FieldArray
                name="commitments"
                render={(arrayHelpers) => {
                  const commitments = values.commitments;
                  {
                  }
                  return (
                    <>
                      <ResponsiveDialog
                        open={isVisibleDialog}
                        header={
                          changeMode
                            ? "Please save your changes first!"
                            : dayChangeMode
                            ? `Please save day ${dayId} data first!`
                            : "Please fill all days data."
                        }
                        dtype="msg"
                        onClose={() => setIsVisibleDialog(false)}
                      ></ResponsiveDialog>

                      <Grid container spacing={3}>
                        <Grid
                          item
                          xs={12}
                          sx={{ mt: 3, ml: 2 }}
                          exact={`${true}`}
                          direction-xs-row-reverse
                        >
                          Day
                          {touched.day && errors.day && (
                            <FormHelperText className="error_message">
                              {errors?.day}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          exact={`${true}`}
                          direction-xs-row-reverse
                          className="heelo"
                        >
                          {(() => {
                            const buttons = [];
                            for (
                              let i = 0;
                              isEdit && getProgramDetails?.duration
                                ? i < getProgramDetails?.duration * 7
                                : programsDetails && programsDetails?.duration
                                ? i < programsDetails?.duration * 7
                                : null;
                              i++
                            ) {
                              buttons.push(
                                <Button
                                  className={
                                    dayId === i + 1
                                      ? "select-day-btn"
                                      : "day-btn"
                                  }
                                  key={i}
                                  onClick={() => {
                                    if (changeMode || dayChangeMode) {
                                      setIsVisibleDialog(true);
                                    } else {
                                      setDayId(i + 1);
                                      setFieldValue("day", i + 1);
                                      setSelectedCommit();
                                      setCommitmentLen();
                                    }
                                  }}
                                >
                                  {i + 1}
                                </Button>
                              );
                            }
                            return buttons;
                          })()}
                        </Grid>

                        <Grid item xs={12}>
                          <CustomTextField
                            fieldType="textInput"
                            name="dayTitle"
                            label="Day Title"
                            placeholder={"Enter Day Title"}
                            fullWidth
                            required
                            value={values.dayTitle}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="day-title"
                            error={
                              touched?.dayTitle && errors?.dayTitle
                                ? true
                                : false
                            }
                          />
                          {touched.dayTitle && errors.dayTitle && (
                            <FormHelperText className="error_message">
                              {errors?.dayTitle}
                            </FormHelperText>
                          )}
                        </Grid>
                      </Grid>
                      <Box>
                        <FormHelperText className="commitments">
                          COMMITMENTS
                        </FormHelperText>
                      </Box>

                      {commitments && commitments.length > 0
                        ? commitments.map((item, index) => (
                            <Box className="inerbox">
                              <Grid container spacing={3} sx={{ my: 1 }}>
                                <Box className="deleteicon">
                                  <Grid item xs={12}>
                                    {changeMode &&
                                      isEdit &&
                                      index === selectedCommit && (
                                        <>
                                          {" "}
                                          <EditIcon
                                            onClick={() => {
                                              setSelectedCommit(index);
                                              setChangeMode(true);
                                            }}
                                            className="delete-icon"
                                          />
                                          {commitments.length !== 1 && (
                                            <DeleteIcon
                                              onClick={() => {
                                                arrayHelpers.remove(index);
                                                values?.commitments?.[index]?.id
                                                  ? dispatch(
                                                      RemoveCommitmentDetails({
                                                        cd_id:
                                                          values?.commitments?.[
                                                            index
                                                          ]?.id,
                                                        c_id: isEdit
                                                          ? tempDayDetails?.id
                                                          : dayDetails?.id,
                                                        type: isEdit
                                                          ? "UPDATE"
                                                          : "CREATE",
                                                      }),

                                                      !loading &&
                                                        setMsgConfig({
                                                          alertOpen: true,
                                                          message:
                                                            "Commitement Details Delete Successfully!",
                                                          severity: "success",
                                                          autoHideDuration: 2000,
                                                        })
                                                    )
                                                  : setToastMsg({
                                                      msg: "remove",
                                                      state: true,
                                                    });
                                              }}
                                              className="delete-icon"
                                            />
                                          )}
                                        </>
                                      )}
                                    {!changeMode &&
                                      isEdit &&
                                      index + 1 <= CommitmentLen && (
                                        <EditIcon
                                          onClick={() => {
                                            setSelectedCommit(index);
                                            setChangeMode(true);
                                          }}
                                          className="delete-icon"
                                        />
                                      )}

                                    {!changeMode &&
                                      commitments.length !== 1 && (
                                        <DeleteIcon
                                          onClick={() => {
                                            arrayHelpers.remove(index);
                                            values?.commitments?.[index]?.id
                                              ? dispatch(
                                                  RemoveCommitmentDetails({
                                                    cd_id:
                                                      values?.commitments?.[
                                                        index
                                                      ]?.id,
                                                    c_id: isEdit
                                                      ? tempDayDetails?.id
                                                      : dayDetails?.id,
                                                    type: isEdit
                                                      ? "UPDATE"
                                                      : "CREATE",
                                                  }),

                                                  !loading &&
                                                    setMsgConfig({
                                                      alertOpen: true,
                                                      message:
                                                        "Commitement Details Delete Successfully!",
                                                      severity: "success",
                                                      autoHideDuration: 2000,
                                                    })
                                                )
                                              : setToastMsg({
                                                  msg: "remove",
                                                  state: true,
                                                });
                                          }}
                                          className="delete-icon"
                                        />
                                      )}
                                  </Grid>

                                  {toastMsg?.msg === "remove" &&
                                    toastMsg?.state === true && (
                                      <Snackbar
                                        handleClose={customHandleClose}
                                        alertOpen={toastMsg?.state}
                                        CustomeMessage="Commitment details deleted successfully!"
                                        customeseverity="success"
                                        autoHideDuration={parseInt("2000")}
                                      />
                                    )}
                                </Box>

                                <Grid item xs={12}>
                                  <CustomTextField
                                    fieldType="textInput"
                                    name={`commitments.${index}.commitment_title`}
                                    label="Commitment Title"
                                    placeholder={"Enter Commitment Title"}
                                    fullWidth
                                    required
                                    className="commitmentTitle"
                                    value={
                                      values.commitments[index].commitment_title
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={
                                      touched?.commitments?.[index]
                                        ?.commitment_title &&
                                      errors?.commitments?.[index]
                                        ?.commitment_title
                                        ? true
                                        : false
                                    }
                                    InputProps={{
                                      readOnly: !isEdit
                                        ? false
                                        : (isEdit &&
                                            index === selectedCommit &&
                                            changeMode) ||
                                          (isEdit &&
                                            index + 1 > CommitmentLen) ||
                                          (isEdit && CommitmentLen == undefined)
                                        ? false
                                        : true,
                                    }}
                                  />

                                  {errors?.commitments?.[index]
                                    ?.commitment_title &&
                                    touched?.commitments?.[index]
                                      ?.commitment_title && (
                                      <FormHelperText className="error_message">
                                        {
                                          errors?.commitments?.[index]
                                            ?.commitment_title
                                        }
                                      </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                  <FormLabel id="demo-controlled-radio-buttons-group">
                                    Cover Image *
                                  </FormLabel>

                                  {errors?.commitments?.[index]?.cover_img &&
                                    touched?.commitments?.[index]
                                      ?.cover_img && (
                                      <FormHelperText className="error_message">
                                        {
                                          errors?.commitments?.[index]
                                            ?.cover_img
                                        }
                                      </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Button
                                    variant="contained"
                                    component="label"
                                    endIcon={<ArrowDropDownCircleIcon />}
                                    className="program-cover-img-btn"
                                    onKeyDown={handleKeyPress1}
                                    disabled={
                                      !isEdit
                                        ? false
                                        : (isEdit &&
                                            index === selectedCommit &&
                                            changeMode) ||
                                          (isEdit &&
                                            index + 1 > CommitmentLen) ||
                                          (isEdit && CommitmentLen == undefined)
                                        ? false
                                        : true
                                    }
                                  >
                                    Select File
                                    <input
                                      name={`commitments.${index}.cover_img`}
                                      accept="image/*"
                                      ref={fileInputRef1}
                                      id="contained-button-file"
                                      type="file"
                                      hidden
                                      onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          const selectedFile = file;
                                          const uniqueString = `___imgc${
                                            index + 1
                                          }`;

                                          const newFileName =
                                            uniqueString +
                                            "_" +
                                            selectedFile.name;
                                          const newFile = new File(
                                            [selectedFile],
                                            newFileName,
                                            { type: selectedFile.type }
                                          );

                                          setFieldValue(
                                            `commitments.${index}.cover_img`,
                                            newFile
                                          );

                                          setFieldValue(
                                            `commitments.${index}.file_name`,
                                            newFile.name
                                          );

                                          setFieldTouched(
                                            `commitments.${index}.cover_img`,
                                            true
                                          );
                                        }
                                      }}
                                    />
                                  </Button>
                                </Grid>
                                <Typography>16:9</Typography>
                                <img
                                  src={
                                    typeof values?.commitments?.[index]
                                      ?.cover_img !== "object"
                                      ? values?.commitments?.[index]?.cover_img
                                      : URL.createObjectURL(
                                          values?.commitments?.[index]
                                            ?.cover_img
                                        )
                                  }
                                  // className="c-img"
                                  width="200px"
                                  height="70px"
                                  alt="N/A"
                                />
                                <Typography>1:1</Typography>
                                <img
                                  src={
                                    typeof values?.commitments?.[index]
                                      ?.cover_img !== "object"
                                      ? values?.commitments?.[index]?.cover_img
                                      : URL.createObjectURL(
                                          values?.commitments?.[index]
                                            ?.cover_img
                                        )
                                  }
                                  // className="c-img"
                                  width="180px"
                                  height="150px"
                                  alt="N/A"
                                />
                                <Grid item xs={12}>
                                  <CustomTextField
                                    fieldType="textInput"
                                    fullWidth
                                    name={`commitments.${index}.short_description`}
                                    label="Short Description"
                                    required
                                    value={
                                      values.commitments[index]
                                        .short_description
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder={
                                      "Enter Commitment Short Description"
                                    }
                                    inputProps={{ maxLength: 130 }}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment
                                          disableTypography
                                          position="end"
                                        >
                                          {`${values.commitments[index].short_description?.length}
                                          /130`}
                                        </InputAdornment>
                                      ),

                                      readOnly: !isEdit
                                        ? false
                                        : (isEdit &&
                                            index === selectedCommit &&
                                            changeMode) ||
                                          (isEdit &&
                                            index + 1 > CommitmentLen) ||
                                          (isEdit && CommitmentLen == undefined)
                                        ? false
                                        : true,
                                    }}
                                    error={
                                      touched?.commitments?.[index]
                                        ?.short_description &&
                                      errors?.commitments?.[index]
                                        ?.short_description
                                        ? true
                                        : false
                                    }
                                  />
                                  {errors?.commitments?.[index]
                                    ?.short_description &&
                                    touched?.commitments?.[index]
                                      ?.short_description && (
                                      <FormHelperText className="error_message">
                                        {
                                          errors?.commitments?.[index]
                                            ?.short_description
                                        }
                                      </FormHelperText>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                  <MyEditor
                                    // onBlur={handleBlur}
                                    value={
                                      values.commitments[index].description
                                    }
                                    name={`commitments.${index}.description`}
                                    onChange={(data) => {
                                      setFieldValue(
                                        `commitments.${index}.description`,
                                        data
                                      );
                                    }}
                                    isReadOnly={
                                      !isEdit
                                        ? false
                                        : (isEdit &&
                                            index === selectedCommit &&
                                            changeMode) ||
                                          (isEdit &&
                                            index + 1 > CommitmentLen) ||
                                          (isEdit && CommitmentLen == undefined)
                                        ? false
                                        : true
                                    }
                                  />
                                  {errors?.commitments?.[index]?.description &&
                                    touched?.commitments?.[index]
                                      ?.description && (
                                      <FormHelperText className="error_message">
                                        {
                                          errors?.commitments?.[index]
                                            ?.description
                                        }
                                      </FormHelperText>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                  <FormLabel id="demo-controlled-radio-buttons-group">
                                    Commitment Content *
                                  </FormLabel>

                                  {errors?.commitments?.[index]?.content_file &&
                                    touched?.commitments?.[index]
                                      ?.content_file && (
                                      <FormHelperText className="error_message">
                                        {
                                          errors?.commitments?.[index]
                                            ?.content_file
                                        }
                                      </FormHelperText>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                  <Button
                                    variant="contained"
                                    component="label"
                                    endIcon={<ArrowDropDownCircleIcon />}
                                    className="program-cover-img-btn"
                                    onKeyDown={handleKeyPress2}
                                    disabled={
                                      !isEdit
                                        ? false
                                        : (isEdit &&
                                            index === selectedCommit &&
                                            changeMode) ||
                                          (isEdit &&
                                            index + 1 > CommitmentLen) ||
                                          (isEdit && CommitmentLen == undefined)
                                        ? false
                                        : true
                                    }
                                  >
                                    Select File
                                    <input
                                      name={`commitments.${index}.content_file`}
                                      // accept={'video/mp4' || 'image/*'}
                                      id="contained-button-file"
                                      type="file"
                                      onBlur={handleBlur}
                                      ref={fileInputRef2}
                                      hidden
                                      onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          const selectedFile = file;
                                          const uniqueString = `___vidc${
                                            index + 1
                                          }`;
                                          const newFileName =
                                            uniqueString +
                                            "_" +
                                            selectedFile.name;
                                          const newFile = new File(
                                            [selectedFile],
                                            newFileName,
                                            { type: selectedFile?.type }
                                          );

                                          setFieldValue(
                                            `commitments.${index}.content_file`,
                                            newFile
                                          );
                                          setFieldValue(
                                            `commitments.${index}.content_file_name`,
                                            newFile.name
                                          );
                                          setFieldTouched(
                                            `commitments.${index}.content_file`,
                                            true
                                          );

                                          if (file.type === "video/mp4") {
                                            const video =
                                              document.createElement("video");
                                            video.preload = "metadata";
                                            video.onloadedmetadata = () => {
                                              URL.revokeObjectURL(video.src);
                                              setFieldValue(
                                                `commitments.${index}.content_duration`,
                                                Math.floor(video.duration)
                                              );
                                            };
                                            video.src =
                                              URL.createObjectURL(file);
                                          } else {
                                            setFieldValue(
                                              `commitments.${index}.content_duration`,
                                              null
                                            );
                                          }
                                        }
                                      }}
                                    />
                                  </Button>
                                </Grid>

                                {typeof values?.commitments?.[index]
                                  ?.content_file == "object" &&
                                values?.commitments?.[index]?.content_file
                                  ?.type == "video/mp4" ? (
                                  <Grid item xs={3}>
                                    <iframe
                                      src={URL.createObjectURL(
                                        values?.commitments?.[index]
                                          ?.content_file
                                      )}
                                      title="content_file"
                                    />
                                  </Grid>
                                ) : values?.commitments?.[index]?.content_file
                                    ?.type === "image/jpg" ||
                                  values?.commitments?.[index]?.content_file
                                    ?.type === "image/jpeg" ||
                                  values?.commitments?.[index]?.content_file
                                    ?.type === "image/png" ? (
                                  <Grid item xs={3}>
                                    <img
                                      src={URL.createObjectURL(
                                        values?.commitments?.[index]
                                          ?.content_file
                                      )}
                                      alt=""
                                      width="200px"
                                      height="200px"
                                    />
                                  </Grid>
                                ) : (
                                  ""
                                )}

                                {typeof values?.commitments?.[index]
                                  ?.content_file === "string" &&
                                  (values?.commitments?.[index]?.content_file
                                    .toLowerCase()
                                    .endsWith(".mp4") ? (
                                    <Grid item xs={3}>
                                      <iframe
                                        src={
                                          values?.commitments?.[index]
                                            ?.content_file
                                        }
                                        title="content_file"
                                      />
                                    </Grid>
                                  ) : (
                                    (values?.commitments?.[index]?.content_file
                                      .toLowerCase()
                                      .endsWith(".jpg") ||
                                      values?.commitments?.[index]?.content_file
                                        .toLowerCase()
                                        .endsWith(".png") ||
                                      values?.commitments?.[index]?.content_file
                                        .toLowerCase()
                                        .endsWith(".jpeg")) && (
                                      <Grid item xs={3}>
                                        <img
                                          src={
                                            values?.commitments?.[index]
                                              ?.content_file
                                          }
                                          alt=""
                                          width="200px"
                                          height="200px"
                                        />
                                      </Grid>
                                    )
                                  ))}
                              </Grid>

                              {isEdit &&
                                index === selectedCommit &&
                                index + 1 <= CommitmentLen &&
                                changeMode && (
                                  <Grid item xs={12}>
                                    <Box className="save-btn-box">
                                      <Button
                                        sx={{
                                          display: "flex",
                                        }}
                                        onClick={() => {
                                          values?.commitments?.[index]?.id &&
                                            setToastMsg({
                                              msg: "update",
                                              state: true,
                                            });
                                          setChangeMode(false);

                                          let payload = {
                                            commitments_details:
                                              values.commitments,
                                            cd_id:
                                              values?.commitments?.[index]?.id,
                                            c_id: tempDayDetails?.id,
                                          };
                                          dispatch({
                                            type: SAVE_SINGLE_COMMITMENT_DETAILS,
                                            payload: payload,
                                          });
                                          setDayChangeMode(true);
                                        }}
                                        variant="contained"
                                        name="update"
                                        className="comit-save-btn"
                                      >
                                        Save Changes
                                      </Button>{" "}
                                    </Box>
                                  </Grid>
                                )}
                            </Box>
                          ))
                        : null}

                      <Grid item xs={12}>
                        <Box className="save-btn-box">
                          <Button
                            sx={{
                              display: "flex",
                            }}
                            onClick={handleSubmit}
                            variant="contained"
                            name="save"
                            // disabled={isSubmitting}
                            className="program-save-btn"
                          >
                            SAVE
                          </Button>
                        </Box>
                      </Grid>
                      <Box sx={{ mb: 2 }}>
                        {commitments.length === 6 ? null : (
                          <Grid item xs={12}>
                            <Box
                              sx={{
                                p: 3,
                                border: "2px dashed grey",
                                background: "#fff",
                                "&:hover": {
                                  cursor: "pointer",
                                },
                              }}
                              onClick={() =>
                                arrayHelpers.push({
                                  commitment_title: "",
                                  cover_img: "",
                                  short_description: "",
                                  description: "",
                                  content_file: "",
                                })
                              }
                            >
                              <Box sx={{ mt: 1, textAlign: "center" }}>
                                <FormLabel className="add-btn">
                                  ADD COMMITMENT
                                </FormLabel>
                              </Box>
                              <Box sx={{ textAlign: "center" }}>
                                <AddCircleOutlineIcon />
                              </Box>
                            </Box>
                          </Grid>
                        )}
                      </Box>

                      <Grid item xs={12} sx={{ mb: 8 }}>
                        <Button
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                          }}
                          variant="contained"
                          className="program-previous-btn"
                          onClick={() => {
                            handleBack();
                          }}
                        >
                          <img src={LeftArrow} alt="" />
                          <span>Previous</span>
                        </Button>

                        <Button
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                          }}
                          onClick={() => {
                            handleNext(values);
                          }}
                          name="next"
                          variant="contained"
                          className="program-next-btn"
                        >
                          <span>Next</span>
                          <img src={rightArrow} alt="" />
                        </Button>
                      </Grid>
                    </>
                  );
                }}
              />
            </Form>
          )}
        />
      )}
    </>
  );
}
